/* eslint-disable import/no-cycle */
import { call, put, takeEvery } from 'redux-saga/effects';
import { commands, receptions, returnVouchers } from '../../api/api';
import { displayLoading, displaySuccess } from '../../utils/toast/Toast';
import logger from '../../utils/logger';
import {
  EXPORT_COMMANDS_REPORT,
  EXPORT_COMMANDS_REPORT_FAILURE,
  EXPORT_COMMANDS_REPORT_SUCCESS,
  EXPORT_RECEPTIONS_COMPARATIVE,
  EXPORT_RECEPTIONS_COMPARATIVE_FAILURE,
  EXPORT_RECEPTIONS_COMPARATIVE_SUCCESS,
  EXPORT_RETURN_VOUCHERS_REPORT,
  EXPORT_RETURN_VOUCHERS_REPORT_FAILURE,
  EXPORT_RETURN_VOUCHERS_REPORT_SUCCESS
} from './exportsActions';

const cleanPayload = payload =>
  Object.entries(payload).reduce((acc, [key, value]) => {
    if (value === '' || value === null || value === undefined) {
      return acc;
    }
    if (Array.isArray(value) && !value.length) {
      return acc;
    }
    return {
      ...acc,
      [key]: value
    };
  }, {});

function downloadBase64File(contentType, base64Data, fileName) {
  const linkSource = `data:${contentType};base64,${base64Data}`;
  const downloadLink = document.createElement('a');
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
}

export function* exportCommandsReport(action) {
  const closeLoading = displayLoading('Préparation de votre fichier en cours');
  try {
    const response = yield call(
      commands.commandsReport,
      cleanPayload(action.payload)
    );
    if (response.data.success === true) {
      yield put({
        type: EXPORT_COMMANDS_REPORT_SUCCESS,
        payload: response.data
      });
      window.location.href = response.data.reportUrl;
      displaySuccess('Fichier téléchargé avec succès');
    } else {
      yield put({ type: EXPORT_COMMANDS_REPORT_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: EXPORT_COMMANDS_REPORT_FAILURE });
  } finally {
    closeLoading();
  }
}

export function* exportReturnVouchersReport(action) {
  const closeLoading = displayLoading('Préparation de votre fichier en cours');
  try {
    const response = yield call(
      returnVouchers.report,
      cleanPayload(action.payload)
    );
    if (response.data.success === true) {
      yield put({
        type: EXPORT_RETURN_VOUCHERS_REPORT_SUCCESS,
        payload: response.data
      });
      window.location.href = response.data.reportUrl;
      displaySuccess('Fichier téléchargé avec succès');
    } else {
      yield put({ type: EXPORT_RETURN_VOUCHERS_REPORT_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: EXPORT_RETURN_VOUCHERS_REPORT_FAILURE });
  } finally {
    closeLoading();
  }
}

export function* exportReceptionsComparative(action) {
  const closeLoading = displayLoading('Préparation de votre fichier en cours');
  try {
    const response = yield call(
      receptions.exportReceptionsComparative,
      cleanPayload(action.payload)
    );
    if (response.data.success === true) {
      yield put({
        type: EXPORT_RECEPTIONS_COMPARATIVE_SUCCESS,
        payload: response.data
      });
      downloadBase64File(
        'application/octet-stream',
        response.data.base64ExcelComparative,
        'comparative.xlsx'
      );
      displaySuccess('Fichier téléchargé avec succès');
    } else {
      yield put({ type: EXPORT_RECEPTIONS_COMPARATIVE_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: EXPORT_RECEPTIONS_COMPARATIVE_FAILURE });
  } finally {
    closeLoading();
  }
}

const exportsSaga = [
  takeEvery(EXPORT_COMMANDS_REPORT, exportCommandsReport),
  takeEvery(EXPORT_RETURN_VOUCHERS_REPORT, exportReturnVouchersReport),
  takeEvery(EXPORT_RECEPTIONS_COMPARATIVE, exportReceptionsComparative)
];

export default exportsSaga;
